import { Badge, Group, Tooltip } from "@mantine/core";
import dayjs from "dayjs";

const DAY_LABELS = {
  PONDĚLÍ: "PO",
  ÚTERÝ: "ÚT",
  STŘEDA: "ST",
  ČTVRTEK: "ČT",
  PÁTEK: "PÁ",
};

const DAY_COLORS = {
  PONDĚLÍ: "blue",
  ÚTERÝ: "grape",
  STŘEDA: "teal",
  ČTVRTEK: "orange",
  PÁTEK: "red",
};

/**
 * Vykreslí koupené dny jednodenního příměstského dítěte jako barevné štítky.
 * Renderuje se jen pro jednodenní děti (child.isSingleDay), jinak nic.
 */
export default function SuburbanDaysBadges({ child }) {
  if (!child?.isSingleDay) {
    return null;
  }

  const days = child.suburbanDays ?? [];
  if (!days.length) {
    return null;
  }

  return (
    <Group gap="xs" mt={4}>
      {days.map((day) => (
        <Tooltip
          key={day.day}
          position="top"
          withArrow
          transition="fade"
          transitionDuration={200}
          label={day.date ? `${day.day} (${dayjs(day.date).format("D. M.")})` : day.day}>
          <Badge size="sm" variant="light" color={DAY_COLORS[day.day] ?? "gray"}>
            {DAY_LABELS[day.day] ?? day.day}
          </Badge>
        </Tooltip>
      ))}
    </Group>
  );
}
